module.exports = __webpack_public_path__ + "static/media/serge.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/designer-profiles/serge.png
// module id = 522
// module chunks = 0